// lib
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

// component
import DashBoardTemplete from '../component/dashBoard/DashBoardTemplete';

// icons
import { FiRefreshCw } from 'react-icons/fi';
import WeeklyProductionChart from '../component/dashBoard/WeeklyProductionChart';
import { AddressVerifyPreview } from '../component/dashBoard/AddressVerifyPreview';
import { EmmShopChangePreview } from '../component/dashBoard/EmmShopChangedPreview';
import { DailyDeliveryChart } from '../component/dashBoard/DailyDeliveryChart';
import { TodaysProduction } from '../component/dashBoard/TodaysProduction';
import { WeeklyProductionTable } from '../component/dashBoard/WeeklyProductionTable';
import { MonthlyOrderAmount } from '../component/dashBoard/MonthlyOrderAmount';
import { OrderAnalysisChartProvider } from '../component/chart/provider/OrderAnalysisChartProvider';
import { getMonthStartEnd } from '../function/replaceString';
import { DashboardPageHeader } from '../component/dashBoard/DashboardPageHeader';
import useFetch from '../api/useFetch';
import {
  inquiriesContainerApi,
  InquiriesContainerType,
  StockHistoryResponseType,
  StockResponseType,
} from '../api/apiConfig';
import { useSelector } from 'react-redux';
import { RootState } from '../store/modules';
import { TableDataType } from '../router/user/pages/Stock';

const Menus = [
  {
    title: '주소검증 요청',
    component: <AddressVerifyPreview />,
  },
  {
    title: '자사쇼핑몰 주문 변경사항',
    component: <EmmShopChangePreview />,
  },
  {
    title: '월간 주문량 순위',
    component: <MonthlyOrderAmount />,
  },
  {
    title: '주간 생산량',
    component: <WeeklyProductionTable />,
  },
  {
    title: '직접배송현황',
    component: <DailyDeliveryChart />,
  },
  {
    title: '금일 생산현황',
    component: <TodaysProduction />,
  },
  // {
  //   title: '결제정보',
  //   component: <></>,
  // },
  // {
  //   title: '서비스 새 소식',
  //   component: <></>,
  // },
  // {
  //   title: '신규서비스',
  //   component: <></>,
  // },
  // {
  //   title: '프로모션',
  //   component: <></>,
  // },
];
const DashBoardPage = () => {
  const prodCdList = [
    'B00002',
    'B00003',
    'B00004',
    'B00061',
    'B00062',
    'B00065',
    'B00067',
    'B00100',
    'B00102',
    'B00104',
    'B00107',
    'B00108',
    'D00001',
    'D00004',
  ];

  const { startDash, endDash } = getMonthStartEnd(new Date());
  const tvMode =
    useSelector((state: RootState) => state.loginUserData?.loginId) === 'e';

  const [tableData, setTableData] = useState<TableDataType[]>([]);

  const stockData: StockResponseType[] = useSelector(
    (state: RootState) => state.socketData.stock
  );

  const stockHistoryData: StockHistoryResponseType[] = useSelector(
    (state: RootState) => state.socketData.stockHistory
  );

  const fetchCount = 1;
  const handleRefresh = () => {
    window.location.href = window.location.href;
  };

  useEffect(() => {
    if (stockData.length < 1) return;
    const combinedData = stockData
      .filter((stock) => prodCdList.some((cd) => cd === stock.prodCd))
      .map((stock) => {
        const targetStockHistory: StockHistoryResponseType[] =
          stockHistoryData.filter(
            (stockHistory) => stockHistory.stockId === stock.stockId
          );
        const data: TableDataType = {
          itemId: stock.itemId,
          prodCd: stock.prodCd,
          prodDes: stock.prodDes,
          qty: stock.qty,
          sizeDes: stock.sizeDes,
          stockId: stock.stockId,
          timeDate: stock.timeData,
          changedQuantity: targetStockHistory
            .map((history) => history.changedQuantity)
            .reduce((sum, quantity) => sum + quantity, 0),
        };
        return data;
      });

    setTableData(combinedData);
  }, [stockData, stockHistoryData]);

  console.log('tableData', tableData);

  const BodyHeader = () => {
    return (
      <OrderAnalysisChartProvider
        startDt={startDash}
        endDt={endDash}
        fetchCount={fetchCount}
      >
        <DashboardPageHeader />
      </OrderAnalysisChartProvider>
    );
  };

  return (
    <Container>
      <Header>
        <ResetButton onClick={handleRefresh}>
          <FiRefreshCw color='#4c4f4c' />
          새로고침
        </ResetButton>
      </Header>

      <BodyHeader />
      <Body>
        {tvMode && (
          <StockTable>
            <Header>
              <Title>{'재고현황'}</Title>
            </Header>
            <Row>
              <div className='des'>주문정보</div>
              <div className='prev'>전일재고</div>
              <div className='changed'>금일생산수량</div>
              <div className='total'>최종수량</div>
            </Row>
            {tableData.length > 0 &&
              tableData.map((stock) => (
                <BodyRow>
                  <div className='des'>{stock.prodDes}</div>
                  <div className='prev'>{stock.qty}</div>
                  <div className='changed'>{stock.changedQuantity}</div>
                  <div className='total'>
                    {stock.qty + stock.changedQuantity}
                  </div>
                </BodyRow>
              ))}
          </StockTable>
        )}
        <Content>
          {Menus.map((menu, index) => (
            <DashBoardTemplete key={index} title={menu.title}>
              {menu.component}
            </DashBoardTemplete>
          ))}
        </Content>
      </Body>
    </Container>
  );
};

export default DashBoardPage;

const Container = styled.div`
  /* padding: 20px 30px; */

  flex: 1;
`;

const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

const StockTable = styled.div`
  padding: 10px;
  width: 700px;
  background-color: white;
  margin-right: 15px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div``;

const Title = styled.div`
  color: #000;
  font-weight: bold;
  font-size: 16px;
`;

const ResetButton = styled.div`
  display: inline-flex;
  gap: 10px;
  align-items: center;
  border: 1px solid #e2e2e2;
  padding: 5px 15px;
  color: #222;
  font-weight: 600;
  cursor: pointer;
`;

const Content = styled.div`
  width: 100%;
  background-color: #edeef1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 15px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 29px;
  font-weight: 600;
  font-size: 12px;
  margin-top: 7px;

  .des {
    flex: 0 0 50%;
    text-align: start;
    overflow: hidden; /* 넘치는 부분 숨김 */
    text-overflow: ellipsis; /* 가려지는 부분 ... 처리 */
    white-space: nowrap; /* 줄 넘김 금지 */
  }
  .prev {
    flex: 1;
    text-align: center;
  }
  .changed {
    flex: 1;
    text-align: center;
  }
  .total {
    flex: 1;
    text-align: center;
  }
`;

const BodyContainer = styled.div`
  height: 210px;
  /* background-color: #f0f0f0; */
  border-top: 1px solid #cccccc7d;
  border-bottom: 1px solid #cccccc7d;
  margin-top: 7px;
  overflow-y: scroll;
`;

const BodyRow = styled(Row)`
  border-bottom: 1px solid #cccccc7d;
  margin-top: 0px;
  font-weight: 500;
`;
